import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import liff from '@line/liff';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';

import { DateTime } from 'luxon';
import md5 from 'md5';
import { Box, Link } from '@mui/material';
import { Mode } from '@mui/icons-material';
import { FacebookCircularProgress } from '../components/progress';
import Iconify from '../components/iconify/Iconify';
import UserService from '../services/user.service';

import { isLocalhost } from '../App';
import ViewUser from '../sections/profile/ViewUser';
import EditUser from '../sections/profile/EditUser';
import Profile from './Profile';

const liffId = '1656457313-l3DG5Bgg' // process.env.REACT_APP_LIFF_ID SUPER ADMIN PAGE

function logOut() {
    liff.logout()
    // setSignedIn(false)
    window.location.reload()
}

function logIn() {
liff.login({ redirectUri: window.location.href })
}

async function getLineProfile() {
    const profile = await liff.getProfile()
    // document.getElementById("pictureUrl").style.display = "block"
    // document.getElementById("pictureUrl").src = profile.pictureUrl
    return profile
}


export default function AdminPage() {


    const queryParams = new URLSearchParams(window.location.search)
    

    const  mode = queryParams.get("mode")
    const  userId = queryParams.get("id")



    const { pathname } = useLocation();
    const [profile, setProfile] = useState({});
    const [liffInfo, setLiffInfo] = useState({})
    const [user, setUser] = useState({});

    // const [scanning, setScanning] = useState(false);
    // const [log, setLog] = useState("LOG appears here");

    useEffect(() => {


        // let user
        if (isLocalhost) {

            const profile = {
              userId: 'abc',
              displayName: 'Chaloemphol',
              statusMessage: 'ev’ry moment new',
              pictureUrl: '/assets/images/avatars/avatar_2.jpg',
              role: 'user'
            }
            setProfile(profile)
        // })
          return undefined
        }

        (async () => {

        //   if (isLocalhost) return
        await liff.init({ liffId, withLoginOnExternalBrowser: false})

        if (!liff.isInClient() && !liff.isLoggedIn()) {
          liff.login()
        }
        await getLineProfile()
          .then( data => {

          //   let profile = data
          //   user = await getLineProfile(data.userId)
          //   if (user) profile = { ...user , ...profile }
              // window.alert(JSON.stringify(data))
            setProfile(data)

          })



          // await liff.init({ liffId, withLoginOnExternalBrowser: false})

          // if (liff.isInClient()) {
          //   // window.alert('ok')
          //   await getLineProfile()
          //   .then( data => {

          //   //   let profile = data
          //   //   user = await getLineProfile(data.userId)
          //   //   if (user) profile = { ...user , ...profile }
          //       // window.alert(JSON.stringify(data))
          //     setProfile(data)

          //   })

          // }
        })()

        return undefined
      }, []);
      
      // useEffect(() => {
      //   (async () => {

      //     await liff.getFriendship()
      //       .then(r => setLiffInfo(i => ({ ...i, 
      //         'isInClient': liff.isInClient(),
      //         'getVersion' : liff.getVersion(),
      //         'getLineVersion' : liff.getLineVersion(),
      //         'friendFlag': r.friendFlag })))          
      //   })()  
      
      // }, [])

   const UI = useMemo(() => {

    switch (mode) {
      case 'viewuser':
        return (<ViewUser liff={liff} userId={userId} setUser={setUser} />);
    
      default:
        return <>{mode}</>
    }
   }, [mode, userId])

   if (profile && !['admin', 'superadmin'].includes(profile.role) && !isLocalhost) return UI
   return (<Box sx={{mt: 10}}>loading {userId} {mode}</Box>)


}